<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0">
            <v-layout row justify-end align-center>
              <v-flex xs12 md2>
                <v-select
                  label="Tòa nhà"
                  :disabled="loader"
                  v-model="chosen_building"
                  :items="list_building"
                  prepend-icon="domain"
                  required
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_date_start"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date_start"
                    label="Ngày bắt đầu"
                    :disabled="loader"
                    prepend-icon="event"
                    readonly
                    hide-details
                  ></v-text-field>
                  <v-date-picker
                    locale="vi-VI"
                    v-model="date_start"
                    @input="menu_date_start = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu_date_end"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  hide-details
                >
                  <v-text-field
                    slot="activator"
                    v-model="date_end"
                    label="Ngày kết thúc"
                    :disabled="loader"
                    prepend-icon="event"
                    readonly
                    hide-details
                  ></v-text-field>
                  <v-date-picker
                    locale="vi-VI"
                    v-model="date_end"
                    @input="menu_date_end = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <div class="mt-3">
            <v-card>
              <v-data-table
                disable-initial-sort
                :headers="headers"
                :items="items"
                item-key="id"
                :rows-per-page-items="rowPerPage"
              >
                <template #items="props">
                  <tr>
                    <td class="text-center text-no-wrap">
                      {{ props.item.receipt_number }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.building }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.receipt_id }}
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.date_deposit | formatTimeServer }}
                    </td>
                    <td class="text-center text-no-wrap">
                      <span
                        class="v-badge primary"
                        v-if="!!props.item.receipt_id"
                      >
                        Cọc lần {{ props.item.deposit_type }}
                      </span>
                      <span class="v-badge error" v-else>
                        Thiếu dữ liệu
                      </span>
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.date_schedule_in | formatTimeServer }}
                    </td>
                    <td class="text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">
                      <span
                        v-if="props.item.receipt_status !== 0"
                        :class="
                          props.item.is_collected
                            ? 'v-badge primary'
                            : 'v-badge warning'
                        "
                      >
                        {{
                          props.item.receipt_status == 2
                            ? "CG đã thu"
                            : "CG chưa thu"
                        }}
                      </span>
                      <span v-else class="v-badge error">Đã hủy cọc</span>
                    </td>
                    <td class="text-no-wrap">
                      {{
                        !props.item.is_check_in
                          ? "Chưa nhận phòng"
                          : "Đã nhận phòng"
                      }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.wallet_account_id | translateWalletName }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.agent_name }}
                    </td>
                    <td class="text-no-wrap">{{ props.item.name }}</td>
                    <td class="text-no-wrap">{{ props.item.phone }}</td>
                    <td class="text-no-wrap">
                      {{ props.item.room_price | formatNumber }}
                    </td>
                    <td class="text-no-wrap">
                      {{ props.item.deposit_amount | formatNumber }}
                    </td>
                    <td class="text-no-wrap">{{ props.item.note }}</td>
                    <!-- <td v-if="role === 'ADMIN'" class="text-no-wrap">
                                    </td> -->
                  </tr>
                </template>
                <template #no-data>
                  Chưa có thông tin
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import api from "Api";
import { buildParamQuery } from "Helpers";
import { room_status } from "Constants/db-config";
import { list_building } from "Constants/db-config";

export default {
  name: "phieu-coc-lien-tuc",
  data() {
    return {
      loader: false,
      headers: [
        {
          text: "Mã phiếu",
          align: "center",
          sortable: true,
          value: "receipt_number",
        },
        {
          text: "Tòa nhà",
          align: "center",
          sortable: true,
          value: "building",
        },
        {
          text: "#Chứng từ thực tế",
          align: "center",
          sortable: true,
          value: "receipt_id",
        },
        {
          text: "Ngày cọc",
          align: "left",
          sortable: true,
          value: "date_deposit",
        },
        {
          text: "Loại",
          align: "center",
          sortable: true,
          value: "deposit_type",
        },
        {
          text: "Hẹn nhận phòng",
          align: "left",
          sortable: true,
          value: "date_schedule_in",
        },
        { text: "Phòng", align: "left", sortable: true, value: "room_id" },
        {
          text: "Trạng thái phiếu",
          align: "center",
          sortable: true,
          value: "receipt_status",
        },
        {
          text: "Trạng thái phòng",
          align: "left",
          sortable: true,
          value: "is_check_in",
        },
        {
          text: "Hình thức",
          align: "center",
          sortable: true,
          value: "wallet_account_id",
        },
        {
          text: "Người dẫn",
          align: "left",
          sortable: true,
          value: "agent_name",
        },
        { text: "Họ tên", align: "left", sortable: false, value: "name" },
        { text: "SDT", align: "left", sortable: false, value: "phone" },
        {
          text: "Giá phòng",
          align: "left",
          sortable: false,
          value: "room_price",
        },
        {
          text: "Số tiền đã cọc",
          align: "left",
          sortable: true,
          value: "deposit_amount",
        },
        { text: "Diễn giải", align: "left", sortable: false },
      ],
      list_building: [...list_building, { text: "Tất cả", value: "" }],
      chosen_building: list_building[0].value,
      items: [],
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
      menu_date_start: false,
      menu_date_end: false,
      date_start: "",
      date_end: "",
      room_status,
    };
  },
  watch: {
    chosen_building: function(nv) {
      this.getData();
    },
    date_start: function(nv) {
      this.getData();
    },
    date_end: function(nv) {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  created() {},
  methods: {
    getData: async function() {
      this.items = [];
      this.loader = true;
      const params = {
        building: this.chosen_building,
        receiptType: "DEPOSIT",
        dateStart: this.date_start,
        dateEnd: this.date_end,
      };
      const query = buildParamQuery(params);
      const results = await api.getReceiptContinuos(query);
      this.items = results.data;
      this.loader = false;
    },
  },
};
</script>
